import { render } from "./SalesReturnDetails.vue?vue&type=template&id=5109ca6c&scoped=true&ts=true"
import script from "./SalesReturnDetails.vue?vue&type=script&lang=ts"
export * from "./SalesReturnDetails.vue?vue&type=script&lang=ts"

import "./SalesReturnDetails.vue?vue&type=style&index=0&id=5109ca6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5109ca6c"]])

export default __exports__